const type = "samples";

export const setSamplesList = (payload) => ({
  execute: (state) => {
    return {
      ...state,
      samplesList: payload,
    };
  },
  type,
});

export const removeSample = (payload) => ({
  execute: (state) => {
    return {
      ...state,
      samplesList: state.samplesList.filter(({ id }) => id !== payload),
    };
  },
  type,
});

export const updateSamplesList = (payload) => ({
  execute: (state) => {
    const index = state.samplesList.findIndex((item) => item.id === payload.id);
    const myState = [...state.samplesList];
    myState.splice(index, 1, payload);
    return {
      ...state,
      samplesList: [...myState],
    };
  },
  type,
});
